import React, { useRef, useState, useEffect } from "react";
import SimpleReactValidator from "simple-react-validator";
import Header from "../../Common/header";
import Footer from "../../Common/footer";
import "../../index.css";
import StepsNavbar from './Components/stepsNavbar';
import FileDropzone from "./Components/fileDropzone";
import { HiInformationCircle } from "react-icons/hi";

export default function FileAttachment(props) {
  const projectData = props.projectData;
  const setProjectData = props.setProjectData;
  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator());

  function next(e) {
    // Check if every file description is 1) not empty, 2) less than 100 characters
    const isDescriptionValid = projectData.files.every(file => {
      const description = file.filedescription;
      return description && description.trim() !== '' && description.length <= 100;
    });

    if (!isDescriptionValid) {
      return;
    }
    
    if (simpleValidator.current.allValid()) {
      props.nextPage();
    } else {
      simpleValidator.current.showMessages();
      window.scrollTo(0, 0);
      forceUpdate(1);
    }

  };

  function previous(e) {
    e.preventDefault();
    props.previousPage();
  };

  /* function handleTermOfAccess() {
    setProjectData((prevState) => ({
      ...prevState,
      TermOfAccess: !projectData.TermOfAccess,
    }));
  }; */

  function handleChangeDataPolicy(e) {
    setProjectData((prevState) => ({
      ...prevState,
      dataPolicy: e.target.value,
    }));
  };

  function onChangeDataPolicy() {
    if (projectData.dataPolicy === "Public") {
      setProjectData((prevState) => ({
        ...prevState,
        sliderValue: 0,
        isPublic: false,
      }));
    } else {
      setProjectData((prevState) => ({
        ...prevState,
        TermOfAccess: false,
        isPublic: true,
      }));
    }
  };

  return (
    <>
      <Header />

      <StepsNavbar currentStep={props.step} setStep={props.setStep} next={next}/>
      <div className="overflow-auto dark:bg-gray-900">
      <form className=" max-w-2xl my-8 sm:my-12 m-auto dark:bg-gray-800 border dark:border-gray-700">
        <div className="bg-gray-100 dark:bg-gray-800 border dark:border-gray-700">
          <div>
            <div>
              <h2 className=" text-center font-bold text-gray-900 sm:text-xl sm:tracking-tight lg:text-3xl py-6 border-b-2 dark:border-gray-600 dark:text-gray-100">
                File Attachment
              </h2>
            </div>
          </div>

          <div className="md:grid md:grid-cols-3 px-8 py-8">
            <div className="md:mt-0 md:col-span-3">
              <div className="rounded-md bg-blue-100 p-4 mb-4 dark:bg-gray-900">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <HiInformationCircle className="h-5 w-5 text-blue-400" aria-hidden="true" />
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-blue-600">Please note,</h3>
                    <div className="mt-2 text-sm text-blue-600">
                      <ul role="list" className="list-disc space-y-1 pl-5">
                        <li>Folder upload is not supported. Please zip all of the files before upload.</li>
                        <li>Maximum of 10 files can be uploaded.</li>
                        <li>Uploaded files should not exceed 50GB in total.</li>
                        {/* <a href="#" className="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600">
                          Request more space
                          <span aria-hidden="true"> &rarr;</span>
                        </a> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <FileDropzone projectData={props.projectData} setProjectData={props.setProjectData}
              />

              {projectData.disabled === true ? (
                <>
                  <div className="rounded-md bg-red-50 p-4 mt-6">
                    <div className="flex">
                      <div className="flex-shrink-0">
                        <svg
                          className="h-5 w-5 text-red-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fillRule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                      <div className="ml-3">
                        <h3 className="text-sm font-medium text-red-800">
                          You have exceeded the quota of uploading files per
                          project
                        </h3>
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    className=" mt-4 flex items-center m-auto px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  >
                    Request more space
                  </button>
                </>
              ) : (
                <></>
              )}


              {/* Used for setting file public/private status */}
              {/* {projectData.files.length === 0 ? (
                <div></div>
              ) : (
                <div className="mt-6 ">
                  <input
                    type="radio"
                    value="Public"
                    onChange={handleChangeDataPolicy}
                    onClick={onChangeDataPolicy}
                    className="mr-2"
                    checked={projectData.dataPolicy === "Public"}
                  />
                  <label for="male" className="mr-8 ">
                    Public
                  </label>

                  <input
                    type="radio"
                    value="Private"
                    onChange={handleChangeDataPolicy}
                    onClick={onChangeDataPolicy}
                    className="mr-2"
                    checked={projectData.dataPolicy === "Private"}
                  />
                  <label for="male">
                    Private{" "}
                    {projectData.dataPolicy === "Public" ? null : (
                      <span className="text-xs text-gray-500 ml-4">
                        (Please select years and terms of access of the files)
                      </span>
                    )}
                  </label>
                </div>
              )} */}

              {/* TERM OF ACCESS CHECKBOX -----------------------------------------------------------*/}
              {/* <div className="md:grid md:grid-cols-3 md:gap-6 px-16 ">
                <div className="md:col-span-1">
                  <div className="px-4 sm:px-0">
                    <h3 className="text-md font-medium leading-6 text-gray-900">
                      Term of Access
                      <span className="text-red-600 font-extrabold border-red-200">
                        * :
                      </span>
                    </h3>
                  </div>
                </div>

                <div className="mt-5 md:mt-0 md:col-span-2 mb-8">
                  <div className="bg-white border-2 text-red-600 font-bold tracking-tight text-xs py-4 px-4">
                    By browsing, visiting or otherwise interacting with the
                    Site, you accept and agree to be bound and comply with
                    these Terms and our Privacy Policy, found at{" "}
                    <a
                      href="/terms-and-conditions"
                      className="text-blue-600"
                      target="_blank"
                    >
                      "Terms"
                    </a>{" "}
                    and{" "}
                    <a
                      href="/privacy-policy"
                      className="text-blue-600"
                      target="_blank"
                    >
                      "Privacy Policy"
                    </a>
                    , incorporated herein by reference. If you do not agree
                    to these Terms or the Privacy Policy, you must not
                    access or use the Site.
                  </div>
                  <div className="mt-4">
                    <input
                      type="checkbox"
                      value={projectData.TermOfAccess}
                      className="mr-2"
                      onChange={handleTermOfAccess}
                      checked={projectData.TermOfAccess}
                    />
                    <label for="male">Accept Terms of Access</label>
                  </div>
                  {simpleValidator.current.message(
                    "Term of Access",
                    projectData.TermOfAccess,
                    "required|accepted",
                    {
                      className: "text-red-600 mt-2",
                    }
                  )}
                </div>
              </div> */}

            </div>
          </div>
        </div>
      </form>
      <div className="flex justify-center mb-12">
        <button
          type="submit"
          className="msm:mr-8 mr-40 py-4 px-11 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={(e) => previous(e)}
        >
          Previous
        </button>

        <button
          type="submit"
          onClick={(e) => next(e)}
          data-cy="next"
          className="flex justify-center py-4 px-14 border rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Next
        </button>
      </div>
      </div>
      <Footer />
    </>
  );
}
